import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/vercel/path0/node_modules/@apollo/experimental-nextjs-app-support/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@dynamo-caffeina-dev/airc-ui-kit/dist/airc-ui-kit.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@dynamo-caffeina-dev/airc-ui-kit/dist/style-props.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@dynamo-caffeina-dev/airc-ui-kit/dist/theme.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/swiper.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/a11y.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/navigation.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/swiper/modules/pagination.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/graphik-regular/graphik-regular.woff\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/graphik-bold/graphik-bold.woff\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"../fonts/graphik-semibold/graphik-semibold.woff\",\"weight\":\"600\",\"style\":\"normal\"}],\"variable\":\"--font-graphik\"}],\"variableName\":\"graphikFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/organisms/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/organisms/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/main.scss");
